import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowBoldRight = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M25.2 14.4 35.76 24 25.2 33.6v-3.84h-9.6V18.24h9.6z" })
});
export default SvgArrowBoldRight;
